export default __webpack_public_path__ + "static/faq-fd1afdf63ebb6092b3242c7862e3059c.png";